import { onMounted } from 'vue';
import { navigationStoreChangeListener } from '@nuxt-common/locator/app/utils/globalStoreChange';
import { FETCH_PREFERRED_STORE } from '#shared/types/actions';

export function useLocationUpdate() {
  const navPreferred = useNavPreferred();
  const fetchPreferredStore = () => navPreferred[FETCH_PREFERRED_STORE]();

  onMounted(() => {
    navigationStoreChangeListener(fetchPreferredStore);
  });
}
